var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.25 17.5L15 11.25L8.75 17.5L21.25 17.5Z","fill":"white"}));
}

ArrowUp.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
